/* 
  考官教师评价
*/
import request from "@/utils/request";

//获取考官教师评价页面参数
export function getParam() {
  return request({
    url: "/examinerteacher/examinerEvaluate/getParam",
    method: "get"
  });
}

//获取考官教师评价分页列表
export function getExaminerEvaluate(params) {
  return request({
    url: "/examinerteacher/examinerEvaluate/getExaminerEvaluate",
    method: "get",
    params
  });
}

// 删除信息
export function deleteInfo(data) {
  return request({
    url: "/examinerteacher/examinerEvaluate/deleteInfo",
    method: "post",
    data
  });
}